import React from 'react';
import { PILOT_PROOF } from '../data/offer';

/**
 * Verifiable facts only — no usage metrics, no ratings, no invented numbers.
 * Setting PILOT_PROOF in data/offer.ts swaps the first stat for real cohort
 * proof once it exists.
 */
const productFacts = [{
  value: '6 + 5',
  label: 'Volumes and bonus packs'
}, {
  value: '75',
  label: 'Printable templates, 53 of them reprintable masters'
}, {
  value: '20 min',
  label: 'The weekly reset that keeps all of it running'
}, {
  value: '0',
  label: 'Curriculum pages. On purpose.'
}];
const stats = PILOT_PROOF ? [PILOT_PROOF, ...productFacts.slice(1)] : productFacts;
export function SocialProofBar() {
  return <section aria-label="What's in the system" className="w-full bg-sage text-white" data-id="element-228" data-mp="2tk9gdjfk2z1z">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-9 sm:py-11" data-id="element-229" data-mp="2olfyzfx5enwj">
        <ul className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-8" data-id="element-230" data-mp="1i417z1dg0tie">
          {stats.map(stat => <li key={stat.label} className="text-center" data-id="element-231" data-mp="1d2lp9fyqmz36">
              <p className="font-serif font-black text-3xl sm:text-4xl leading-none" data-id="element-232" data-mp="18nt376bkl8mi">
                {stat.value}
              </p>
              <p className="mt-2 text-xs sm:text-sm text-white/80 leading-snug max-w-[15rem] mx-auto" data-id="element-233" data-mp="1dmvuzp2jhicj">
                {stat.label}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}